import { z } from 'zod';

export const agentConfigSchema = z.object({
  agent: z.object({
    name: z.string({ message: 'Name is required' }).min(1, { message: 'Name is required' }),
    voice_id: z.string({ message: 'Voice is required' }),
    concurrent_answer_generation: z
      .union([
        z.string().nonempty({
          message: 'Concurrent answer generation must be a valid number'
        }),
        z.number()
      ])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Concurrent answer generation must be a valid number'
      }),
    answer_length: z
      .union([z.string().nonempty({ message: 'Answer length must be a valid number' }), z.number()])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Answer length must be a valid number'
      }),
    silence_message_delay: z
      .union([
        z.string().nonempty({
          message: 'Silence message delay must be a valid number'
        }),
        z.number()
      ])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Silence message delay must be a valid number'
      }),
    silence_end_call: z
      .union([z.string().nonempty({ message: 'Silence end call must be a valid number' }), z.number()])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Silence end call must be a valid number'
      })
  })
});

export const customizeBehaviorSchema = z.object({
  agent: z.object({
    agent_type: z.string({ message: 'Agent type is required' }).nonempty({ message: 'Agent type cannot be empty' }),
    tone: z.string({ message: 'Tone is required' }).nonempty({ message: 'Tone cannot be empty' }),
    goal: z.string({ message: 'Goal is required' }).nonempty({ message: 'Goal cannot be empty' }),
    background: z.string({ message: 'Background is required' }).nonempty({ message: 'Background cannot be empty' }),
    instructions: z
      .string({ message: 'Instructions are required' })
      .nonempty({ message: 'Instructions cannot be empty' })
  })
});

export const storeInfoSchema = z.object({
  agent: z.object({
    agent_type: z.string({ message: 'Agent type is required' }).nonempty({ message: 'Agent type cannot be empty' }),
    tone: z.string({ message: 'Tone is required' }).nonempty({ message: 'Tone cannot be empty' }),
    goal: z.string({ message: 'Goal is required' }).nonempty({ message: 'Goal cannot be empty' }),
    background: z.string({ message: 'Background is required' }).nonempty({ message: 'Background cannot be empty' }),
    instructions: z
      .string({ message: 'Instructions are required' })
      .nonempty({ message: 'Instructions cannot be empty' }),
    physical_location_exists: z.union([
      z.string().nonempty({
        message: 'Physical location exists is required'
      }),
      z.boolean()
    ]),
    name: z.string({ message: 'Name is required' }).nonempty({ message: 'Name cannot be empty' }),
    voice_id: z.number({ message: 'Voice is required' }),
    language: z.any().optional(),
    enable_welcome_message: z.any().optional(),
    enable_call_recording: z.any().optional(),
    answer_creativity: z.any().optional(),
    speech_stop_sensitivity: z.any().optional(),
    concurrent_answer_generation: z
      .union([
        z.string().nonempty({
          message: 'Concurrent answer generation must be a valid number'
        }),
        z.number()
      ])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Concurrent answer generation must be a valid number'
      }),
    answer_length: z
      .union([z.string().nonempty({ message: 'Answer length must be a valid number' }), z.number()])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Answer length must be a valid number'
      }),
    silence_message_delay: z
      .union([
        z.string().nonempty({
          message: 'Silence message delay must be a valid number'
        }),
        z.number()
      ])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Silence message delay must be a valid number'
      }),
    silence_end_call: z
      .union([z.string().nonempty({ message: 'Silence end call must be a valid number' }), z.number()])
      .refine((val) => !isNaN(Number(val)), {
        message: 'Silence end call must be a valid number'
      }),
    transcribe_filler_words: z.any().optional(),
    welcome_message: z.any().optional(),
    location_name: z.any().optional(),
    business_address: z.any().optional(),
    industry: z.any().optional(),
    business_hours: z
      .object({
        monday: z
          .object({
            open: z.union([z.boolean(), z.any()]).optional(),
            from_time: z.union([z.string().nonempty(), z.any()]).optional(),
            to_time: z.union([z.string().nonempty(), z.any()]).optional()
          })
          .optional(),
        tuesday: z
          .object({
            open: z.union([z.boolean(), z.any()]).optional(),
            from_time: z.union([z.string().nonempty(), z.any()]).optional(),
            to_time: z.union([z.string().nonempty(), z.any()]).optional()
          })
          .optional(),
        wednesday: z
          .object({
            open: z.union([z.boolean(), z.any()]).optional(),
            from_time: z.union([z.string().nonempty(), z.any()]).optional(),
            to_time: z.union([z.string().nonempty(), z.any()]).optional()
          })
          .optional(),
        thursday: z
          .object({
            open: z.union([z.boolean(), z.any()]).optional(),
            from_time: z.union([z.string().nonempty(), z.any()]).optional(),
            to_time: z.union([z.string().nonempty(), z.any()]).optional()
          })
          .optional(),
        friday: z
          .object({
            open: z.union([z.boolean(), z.any()]).optional(),
            from_time: z.union([z.string().nonempty(), z.any()]).optional(),
            to_time: z.union([z.string().nonempty(), z.any()]).optional()
          })
          .optional(),
        saturday: z
          .object({
            open: z.union([z.boolean(), z.any()]).optional(),
            from_time: z.union([z.string().nonempty(), z.any()]).optional(),
            to_time: z.union([z.string().nonempty(), z.any()]).optional()
          })
          .optional(),
        sunday: z
          .object({
            open: z.union([z.boolean(), z.any()]).optional(),
            from_time: z.union([z.string().nonempty(), z.any()]).optional(),
            to_time: z.union([z.string().nonempty(), z.any()]).optional()
          })
          .optional()
      })
      .optional()
  })
});
